(function () {
  'use strict';

  var overlay = null;
  var selectedVariantId = null;
  var currentVariants = [];

  function buildOverlay() {
    if (overlay) return;

    overlay = document.createElement('div');
    overlay.className = 'ec-atc-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML = [
      '<div class="ec-atc-modal">',
        '<div class="ec-atc-modal__header">',
          '<h3>Adicionar ao Carrinho</h3>',
          '<button class="ec-atc-modal__close" aria-label="Fechar">&times;</button>',
        '</div>',
        '<div class="ec-atc-modal__body">',
          '<div class="ec-atc-modal__image">',
            '<img src="" alt="" id="ec-atc-img">',
          '</div>',
          '<div class="ec-atc-modal__info">',
            '<p class="ec-atc-modal__title" id="ec-atc-title"></p>',
            '<p class="ec-atc-modal__color" id="ec-atc-color"></p>',
            '<p class="ec-atc-modal__size-label">Selecione o tamanho:</p>',
            '<div class="ec-atc-modal__sizes" id="ec-atc-sizes"></div>',
            '<p class="ec-atc-size-error" id="ec-atc-error">Por favor, selecione um tamanho.</p>',
            '<div class="ec-atc-modal__actions">',
              '<button class="ec-atc-btn ec-atc-btn--outline" id="ec-atc-continue">Continuar Comprando</button>',
              '<button class="ec-atc-btn ec-atc-btn--solid" id="ec-atc-go-cart">Ir Para o Carrinho</button>',
            '</div>',
          '</div>',
        '</div>',
      '</div>'
    ].join('');

    document.body.appendChild(overlay);

    overlay.querySelector('.ec-atc-modal__close').addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('ec-atc-overlay--open')) closeModal();
    });

    overlay.querySelector('#ec-atc-continue').addEventListener('click', handleContinue);
    overlay.querySelector('#ec-atc-go-cart').addEventListener('click', handleGoToCart);
  }

  function openModal(btn) {
    buildOverlay();

    var title = btn.getAttribute('data-product-title') || '';
    var color = btn.getAttribute('data-product-color') || '';
    var image = btn.getAttribute('data-product-image') || '';
    var variantsRaw = btn.getAttribute('data-variants') || '[]';

    try {
      currentVariants = JSON.parse(variantsRaw);
    } catch (e) {
      currentVariants = [];
    }

    overlay.querySelector('#ec-atc-img').src = image;
    overlay.querySelector('#ec-atc-img').alt = title;
    overlay.querySelector('#ec-atc-title').textContent = title;

    var colorEl = overlay.querySelector('#ec-atc-color');
    if (color) {
      colorEl.innerHTML = 'Cor: <strong>' + color + '</strong>';
      colorEl.style.display = '';
    } else {
      colorEl.style.display = 'none';
    }

    var hasOption2 = currentVariants.some(function (v) { return v.option2; });
    var sizeKey = hasOption2 ? 'option2' : 'option1';

    var seen = [];
    var uniqueSizes = [];
    currentVariants.forEach(function (v) {
      var label = v[sizeKey];
      if (label && seen.indexOf(label) === -1) {
        seen.push(label);
        uniqueSizes.push({ label: label, variant: v });
      }
    });

    var sizesEl = overlay.querySelector('#ec-atc-sizes');
    sizesEl.innerHTML = '';
    selectedVariantId = null;

    uniqueSizes.forEach(function (item) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ec-atc-size-btn';
      btn.textContent = item.label;
      if (!item.variant.available) {
        btn.classList.add('ec-atc-size-btn--unavailable');
        btn.disabled = true;
      }
      btn.addEventListener('click', function () {
        if (!item.variant.available) return;
        clearSizeError();
        sizesEl.querySelectorAll('.ec-atc-size-btn').forEach(function (b) {
          b.classList.remove('ec-atc-size-btn--active');
        });
        btn.classList.add('ec-atc-size-btn--active');
        selectedVariantId = item.variant.id;
      });
      sizesEl.appendChild(btn);
    });

    if (uniqueSizes.length === 1 && uniqueSizes[0].variant.available) {
      sizesEl.querySelector('.ec-atc-size-btn').classList.add('ec-atc-size-btn--active');
      selectedVariantId = uniqueSizes[0].variant.id;
    }

    clearSizeError();
    overlay.classList.add('ec-atc-overlay--open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!overlay) return;
    overlay.classList.remove('ec-atc-overlay--open');
    document.body.style.overflow = '';
    selectedVariantId = null;

    var continueBtn = overlay.querySelector('#ec-atc-continue');
    var goCartBtn = overlay.querySelector('#ec-atc-go-cart');
    if (continueBtn) continueBtn.disabled = false;
    if (goCartBtn) goCartBtn.disabled = false;
  }

  function showSizeError() {
    var el = overlay.querySelector('#ec-atc-error');
    if (el) el.classList.add('ec-atc-size-error--visible');
  }

  function clearSizeError() {
    if (!overlay) return;
    var el = overlay.querySelector('#ec-atc-error');
    if (el) el.classList.remove('ec-atc-size-error--visible');
  }

  function addToCart(variantId, withSections) {
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (withSections) {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) { return res.json(); });
  }

  function openCartDrawer(response) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(response);
    }
  }

  function handleContinue() {
    if (!selectedVariantId) { showSizeError(); return; }
    var btn = overlay.querySelector('#ec-atc-continue');
    btn.disabled = true;
    addToCart(selectedVariantId, true).then(function (response) {
      closeModal();
      openCartDrawer(response);
    }).catch(function () {
      btn.disabled = false;
    });
  }

  function handleGoToCart() {
    if (!selectedVariantId) { showSizeError(); return; }
    var btn = overlay.querySelector('#ec-atc-go-cart');
    btn.disabled = true;
    addToCart(selectedVariantId, false).then(function () {
      window.location.href = '/cart';
    }).catch(function () {
      btn.disabled = false;
    });
  }

  function bindButtons() {
    var buttons = document.querySelectorAll('.ec-hover-atc-btn:not([data-ec-bound])');
    buttons.forEach(function (btn) {
      btn.setAttribute('data-ec-bound', '1');
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        openModal(btn);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindButtons);
  } else {
    bindButtons();
  }

  document.addEventListener('shopify:section:load', bindButtons);
})();
